import type { ComponentProps, KeyboardEvent, MouseEvent } from 'react'

import { openModal } from 'lib/utils'
import { Button } from 'components/atoms/Button'
import type { EModalType } from 'components/organisms/modals/enums'
import type {
  EButtonVariant,
  EButtonStyleVariant,
} from 'components/atoms/Button/types'

interface ModalLinkProps extends Omit<
  ComponentProps<'a'>,
  'href' | 'onClick' | 'onKeyDown'
> {
  modal: EModalType | null
  href?: never
  variant?: EButtonVariant
  buttonVariant?: EButtonStyleVariant
}

export const ModalLink = ({
  modal,
  className,
  children,
  variant,
  buttonVariant,
  ...props
}: ModalLinkProps) => {
  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    if (modal) openModal(modal)
  }

  const handleKeyDown = (e: KeyboardEvent<HTMLAnchorElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      if (modal) openModal(modal)
    }
  }

  return (
    <Button
      href="#"
      variant={variant}
      buttonVariant={buttonVariant}
      className={className}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="button"
      aria-label={`Open ${modal} modal`}
      {...props}
    >
      {children}
    </Button>
  )
}
